<template>
  <div class="qty-wrap">
    <div class="qty">
      <a href="#" @click.prevent="minus">
        <span class="icon-icon16"></span>
      </a>
      <span class="qty-num">{{ qty }}</span>
      <a href="#" @click.prevent="add">
        <span class="icon-icon17"></span>
      </a>
    </div>
    <a href="#" class="cart_btn" @click.prevent="addCart">
      <span class="icon-icon1"></span>
    </a>
  </div>
</template>


<script>
export default {
  props: ["id"],
  data() {
    return {
      qty: 1,
      stock: 0,
    };
  },
  methods: {
    add() {
        this.qty++;
    },

    minus() {
      if (this.qty > 1) {
        this.qty--;
      }
    },

    addCart() {
      eventHub.$emit("addCart", { id: this.id, qty: this.qty });
    },

    askQty() {
        let url = `/carts/askQty/${this.row}`;
        let vm = this;
        axios.get(url).then( r => {
            vm.stock = r.data.qty;
        });
    },
  }
};
</script>
